module.exports = __webpack_public_path__ + "components/country-flag/static/gs-cdd60ef1c1e18b712224f77ca148e30b.svg";